import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useDebouncedSentenceRefresh } from '../../hooks/useDebouncedSentenceRefresh';
import CustModal from '../../../HOC/CustModal'
import Pare from '../../../HOC/ProgressNote/Pare'
import { userData } from './ViewDetail'
import { postRequest, Url } from '../CustomHttp'
import { getSession } from '../Session'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { debounce } from 'lodash'
import Loader from 'react-loader-spinner'
import moment from 'moment'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField'
import $ from "jquery";
import '../../components/customPractice/CustomPracticeHeaderFields.css';
import {
    isCustomPracticeAccount,
    CUSTOM_PRACTICE_META_DEFAULTS,
    applyCustomPracticeFieldChange,
    resolveSessionDurationForPreview,
    resolveCustomPracticeDisplaySessionMinutes,
    getCustomPracticeMetaFromClient,
    mergeProgressNoteSessionMetaFromDoc,
    mergeLiveCustomPracticeSessionMeta,
    buildCustomPracticeSentenceRequestPayload,
    normalizeCustomPracticeFrontJson,
    scheduleFrontJsonCheckboxRestore,
    resolveSessionDurationMinutes,
    buildDocumentSavePayload,
    rememberAssessmentDraftId,
    resolveDocumentSignatures,
    buildSignatureParagraphHtml,
    formatSignatureLine,
    resolveSignOffButtonState,
    isDocumentContentEditable,
    isDocumentViewOnlyInEditor,
    resolveDocumentEditorAccess,
    buildStoreClientDocumentViewEditFlag,
    isClinicianFinalSignOnly,
    getSignOffButtonLabel,
    getSignOffConfirmPrompt,
    normalizeDocumentSignStatus,
    readAssessmentDraftId,
    clearAssessmentDraftId,
    stripEmbeddedSignaturesFromHtml,
    resolveDocumentCreatedBy,
    resolveDocumentSignStatusesFromApi,
} from '../../utils/customPractice';
import CustomPracticeHeaderFields, {
    CustomPracticeSessionDuration,
} from '../../components/customPractice/CustomPracticeHeaderFields';

const AssessmentBaseJson = require('./Assessment.json');

function Assessment(props) {
    let checkSigned = 0;
    let supervisorSigned = 0;
    let showSigned = 0;

    const { userInfo, changePage, editId } = useContext(userData);
    const isCustomPractice = isCustomPracticeAccount();
    const [AssessmentJson] = useState(AssessmentBaseJson);
    const [customPracticeMeta, setCustomPracticeMeta] = useState({
        ...getCustomPracticeMetaFromClient(userInfo),
    });
    const customPracticeMetaRef = useRef(customPracticeMeta);
    customPracticeMetaRef.current = customPracticeMeta;
    const [commonData, setCommonData] = useState({
        date_of_service: new Date(),
        showError: false,
        count: 0,
        sessionDuration: '',
        sessionDurationCheck: '',
    })
    const [Statement, setStatement] = useState('');
    const [viewEdit, setViewEdit] = useState({ confirmChange: false, diagnosis: userInfo.client_diagnosis ?? [], changeId: false, showModal: false, client_document_id: 0, confirmSave: false, editData: false, viewStatement: false, editBy: '', editTime: '', signed_at: '', signed: 1, supervisorSigned: 1, is_updated: 0, created_by: 0, supervisor_signed_by: 0 });
    const [Data, setData] = useState('');
    const [SignOff, setSignOff] = useState({ signOff: false, signOffConfirm: false, signed: 1, supervisor_signed: 1 });
    // const [latestPiData, setLatestPiData] = useState()
    const [payloadData, setPayloadData] = useState()
    const [selectAllData, setSelectAllData] = useState({})
    const [sentenceLoader, setSentenceLoader] = useState(false)
    const [checkboxLoader, setCheckboxLoader] = useState(false)
    const [selectedSearchIndex, setSelectedSeachIndex] = useState(0)
    const [totalSearch, setTotalSearch] = useState(0)
    const searchRef = useRef(null)

    const URL = '/assessment-sentence-builder';

    const syncSessionDurationMinutes = (totalMinutes) => {
        const minutes = resolveSessionDurationMinutes(totalMinutes, true);
        if (minutes !== '' && minutes !== null && minutes !== undefined) {
            setCommonData((prev) => ({
                ...prev,
                sessionDuration: String(minutes),
                sessionDurationCheck: String(minutes),
            }));
        }
    };

    const applyCustomPracticeFromDoc = (doc) => {
        if (!isCustomPractice || !doc) {
            return;
        }
        const meta = mergeProgressNoteSessionMetaFromDoc(doc, userInfo);
        setCustomPracticeMeta(meta);
        syncSessionDurationMinutes(
            resolveCustomPracticeDisplaySessionMinutes(meta, doc.session_duration)
        );
    };

    useEffect(() => {
        if (isCustomPractice && userInfo?.id) {
            setCustomPracticeMeta((prev) => ({
                ...getCustomPracticeMetaFromClient(userInfo),
                ...prev,
                ref_id: prev.ref_id || userInfo.ref_id || '',
                ins_id: prev.ins_id || userInfo.ins_id || '',
            }));
        }
    }, [isCustomPractice, userInfo?.id, userInfo?.ref_id, userInfo?.ins_id]);

    const headerPreviewEpochRef = useRef(0);
    const accordionPreviewEpochRef = useRef(0);
    const skipMetaRefreshOnLoadRef = useRef(editId > 0);

    const refreshStatementWithCustomMeta = useCallback(
        async (meta) => {
            if (!isCustomPractice || viewEdit.client_document_id === 0) {
                return;
            }
            const session = getSession('userData') || {};
            if (
                !isDocumentContentEditable(
                    viewEdit.signed,
                    viewEdit.supervisorSigned,
                    userInfo.user_role_slug,
                    session.id,
                    userInfo.creator_id
                )
            ) {
                return;
            }
            const requestId = ++headerPreviewEpochRef.current;
            const sessionDuration =
                resolveCustomPracticeDisplaySessionMinutes(
                    meta,
                    commonData.sessionDuration
                ) || commonData.sessionDuration;
            try {
                const postdata = await postRequest(
                    URL,
                    buildCustomPracticeSentenceRequestPayload({
                        payloadData,
                        editData: viewEdit.editData,
                        userInfo,
                        viewEdit,
                        commonData,
                        customPracticeMeta: meta,
                        metaOverride: meta,
                        sessionDuration,
                    }),
                    true
                );
                if (requestId !== headerPreviewEpochRef.current) {
                    return;
                }
                if (postdata?.paragraph) {
                    setStatement(postdata.paragraph);
                }
            } catch {
                // ignore preview refresh failures
            }
        },
        [
            isCustomPractice,
            payloadData,
            viewEdit,
            userInfo,
            commonData,
            URL,
            customPracticeMeta,
        ]
    );

    const scheduleMetaRefresh = useDebouncedSentenceRefresh(
        refreshStatementWithCustomMeta,
        [URL, viewEdit.client_document_id, isCustomPractice]
    );

    useEffect(() => {
        if (!isCustomPractice || !viewEdit.client_document_id) {
            return;
        }
        if (skipMetaRefreshOnLoadRef.current) {
            skipMetaRefreshOnLoadRef.current = false;
            return;
        }
        scheduleMetaRefresh(customPracticeMeta);
    }, [viewEdit.client_document_id, isCustomPractice]);

    const onCustomPracticeFieldChange = (field) => (e) => {
        const value = e.target.value;
        let nextMeta;
        let computedMinutes;
        setCustomPracticeMeta((prev) => {
            const result = applyCustomPracticeFieldChange(prev, field, value);
            nextMeta = result.next;
            computedMinutes = result.computed;
            return nextMeta;
        });
        if (computedMinutes != null && computedMinutes !== undefined) {
            syncSessionDurationMinutes(computedMinutes);
            setCommonData((prev) => ({
                ...prev,
                sessionDuration: String(computedMinutes),
                sessionDurationCheck: String(computedMinutes),
            }));
            if (viewEdit.client_document_id !== 0) {
                postRequest(
                    '/update-session-duration',
                    {
                        sessionDuration: computedMinutes,
                        client_document_id: viewEdit.client_document_id,
                    },
                    true
                );
            }
        } else if (
            nextMeta &&
            (!nextMeta.start_time?.trim() || !nextMeta.end_time?.trim())
        ) {
            syncSessionDurationMinutes(0);
            setCommonData((prev) => ({
                ...prev,
                sessionDuration: '0',
                sessionDurationCheck: '0',
            }));
            if (viewEdit.client_document_id !== 0) {
                postRequest(
                    '/update-session-duration',
                    {
                        sessionDuration: 0,
                        client_document_id: viewEdit.client_document_id,
                    },
                    true
                );
            }
        }
        if (nextMeta) {
            customPracticeMetaRef.current = nextMeta;
            setPayloadData((prev) => ({
                ...(prev && typeof prev === 'object' ? prev : {}),
                ...nextMeta,
            }));
            const commitOnlyField = field === 'ref_id' || field === 'ins_id';
            const runImmediately =
                field === 'place_of_service' ||
                field === 'method_of_contact' ||
                field === 'start_time' ||
                field === 'end_time';
            if (commitOnlyField) {
                return;
            }
            accordionPreviewEpochRef.current += 1;
            if (runImmediately) {
                refreshStatementWithCustomMeta(nextMeta);
            } else {
                scheduleMetaRefresh(nextMeta);
            }
        }
    };

    const onCustomPracticeFieldCommit = () => {
        const meta = customPracticeMetaRef.current;
        if (meta && typeof meta === 'object') {
            accordionPreviewEpochRef.current += 1;
            refreshStatementWithCustomMeta(meta);
        }
    };

    const onSelectedSearchIndex = (flag) => {
        const myVar = $('.searchingTextBG');
        setTotalSearch(myVar.length);
        if (myVar.length > 0) {
            $('.collapse').addClass('show');
        }
        $('.selectedSearchIndex').removeClass('selectedSearchIndex');
        let indexFlag = 0;
        if (flag === 'up') {
            if (selectedSearchIndex === 0) {
                setSelectedSeachIndex(myVar.length - 1);
                indexFlag = myVar.length - 1;
            } else {
                setSelectedSeachIndex(selectedSearchIndex - 1);
                indexFlag = selectedSearchIndex - 1;
            }
        } else if (selectedSearchIndex === myVar.length - 1) {
            setSelectedSeachIndex(0);
            indexFlag = 0;
        } else {
            setSelectedSeachIndex(selectedSearchIndex + 1);
            indexFlag = selectedSearchIndex + 1;
        }
        $(myVar[indexFlag]).addClass('selectedSearchIndex');
        myVar[indexFlag].scrollIntoView({ block: 'center' });
    };

    const onChangeHandler = (e) => {
        if (e.target.value === '' || !e.target.value) {
            setSelectedSeachIndex(0);
            setTotalSearch(0);
            $('.collapsible').removeClass('show');
            const parentCollapse = $('.parentCollapsibleCheckbox input');
            for (let i = 0; i < parentCollapse.length; i++) {
                if ($(`#${parentCollapse[i].id}`).is(':checked')) {
                    const name = $(`#${parentCollapse[i].id}`).attr('id');
                    $(`#${name}Collapse`).addClass('show');
                }
            }
            const value = e.target.value;
            const myVar = $('.searchingTextBG');
            for (let l = 0; l < myVar.length; l++) {
                const findElement = $(myVar[l])[0];
                findElement.innerHTML = findElement.innerHTML.replaceAll(
                    /<span class="searchingTextBG">/gi,
                    ''
                );
            }
            const pattern = new RegExp(`(${value})(?![^<>]*>)`, 'ig');
            for (let index = 0; index < $('.collapsible').length; index++) {
                const element = $('.collapsible')[index];
                for (let k = 0; k < $('label', element).length; k++) {
                    const Parentelement = $('label', element)[k];
                    const elementText = $(Parentelement).text();
                    $(Parentelement).html(
                        elementText.replaceAll(pattern, (str) => str)
                    );
                }
            }
        } else {
            const value = e.target.value;
            const myVar = $('.searchingTextBG');
            if (value !== '') {
                $('.collapse').addClass('show');
            }
            for (let l = 0; l < myVar.length; l++) {
                const findElement = $(myVar[l])[0];
                let s = findElement.innerHTML.replaceAll(
                    /<span class="searchingTextBG">/gi,
                    ''
                );
                s = s.replaceAll(/<\/span>/gi, '');
                findElement.innerHTML = s;
            }
            const pattern = new RegExp(`(${value})(?![^<>]*>)`, 'ig');
            for (let index = 0; index < $('.collapsible').length; index++) {
                const element = $('.collapsible')[index];
                for (let k = 0; k < $('label', element).length; k++) {
                    const Parentelement = $('label', element)[k];
                    const elementText = $(Parentelement).text();
                    $(Parentelement).html(
                        elementText.replaceAll(
                            pattern,
                            (str) => `<span class='searchingTextBG'>${str}</span>`
                        )
                    );
                }
            }
        }
        if (e.target.value !== '') {
            onSelectedSearchIndex('down');
        }
    };

    const onOptimisedHandleChange = debounce(onChangeHandler, 350);

    const clearSearch = () => {
        if (searchRef.current) {
            searchRef.current.value = '';
        }
        setSelectedSeachIndex(0);
        setTotalSearch(0);
        const myVar = $('.searchingTextBG');
        for (let l = 0; l < myVar.length; l++) {
            const findElement = $(myVar[l])[0];
            findElement.innerHTML = findElement.innerHTML.replaceAll(
                /<span class="searchingTextBG">/gi,
                ''
            );
        }
    };

    /** Custom practice on Assessment: session header only — no Objectives (Progress Note only). */
    const loadAssessmentTreatmentPlanMeta = async () => {
        if (!isCustomPractice) {
            return;
        }
        const postData = await postRequest(
            '/latest-notes',
            { client_id: userInfo.id },
            true
        );
        if (postData?.status && postData.data?.notes_id) {
            setViewEdit((prev) => ({
                ...prev,
                notes_id: postData.data.notes_id,
            }));
        }
    };

    const saveStatement = async () => {
        const session = getSession('userData') || {};
        if (
            isDocumentViewOnlyInEditor({
                editId,
                documentMetaLoaded,
                signed: viewEdit.signed,
                supervisorSigned: viewEdit.supervisorSigned,
                userRoleSlug: userInfo.user_role_slug,
                userId: session.id,
                clientCreatorId: userInfo.creator_id,
            })
        ) {
            return;
        }
        const viewEditFlag = buildStoreClientDocumentViewEditFlag(viewEdit.confirmChange);
        const savePayload = buildDocumentSavePayload({
            payloadData,
            editData: viewEdit.editData,
            extras: {
                client_document_id: viewEdit.client_document_id,
                view_edit_flag: viewEditFlag,
                sessionDuration:
                    resolveCustomPracticeDisplaySessionMinutes(
                        customPracticeMeta,
                        commonData.sessionDuration
                    ) ||
                    commonData.sessionDuration,
                ...(isCustomPractice ? customPracticeMeta : {}),
            },
        });
        const postData = await postRequest("/store-client-document", { Statement, data: savePayload, 'document_type': 'assessment', 'client_id': userInfo.id, client_document_id: viewEdit.client_document_id }, true);
        if (postData) {
            const frontJson = normalizeCustomPracticeFrontJson(savePayload);
            setViewEdit((prev) => ({
                ...prev,
                client_document_id: postData.client_document_id,
                confirmSave: true,
                confirmChange: prev.confirmChange || Boolean(viewEditFlag),
                editData: frontJson,
                created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
            }));
            setSelectAllData(frontJson);
            rememberAssessmentDraftId(userInfo.id, postData.client_document_id);
        }
    }

    const signOffFun = async () => {
        // console.log(userInfo);
        const resq = { 
            client_document_id: viewEdit.client_document_id, 
            'document_type': 'assessment',
            'client_id': userInfo.id,
            signed: SignOff.signed,
            supervisor_signed: SignOff.supervisor_signed,
        };
        //supervisor_signed: userInfo.user_supervisor_id ? SignOff.supervisor_signed : 0 
        // console.log(resq);
        const postData = await postRequest("/client-document-update-status", resq, true);
        if (postData) {
            clearAssessmentDraftId(userInfo.id);
            changePage({ id: 6 })
        }
    }
    const [loading, setLoading] = useState(false)
    const [documentMetaLoaded, setDocumentMetaLoaded] = useState(!(editId > 0))

    const applyLoadedClientDocument = (postData, documentId) => {
        const { signed, supervisorSigned } = resolveDocumentSignStatusesFromApi(
            postData.data
        );
        const frontJson = normalizeCustomPracticeFrontJson(
            JSON.parse(postData.data.front_json)
        );
        applyCustomPracticeFromDoc(postData.data);
        setStatement(postData.data.paragraph);
        setViewEdit((prev) => ({
            ...prev,
            confirmChange: postData.data.view_edit_flag ? true : false,
            client_document_id: documentId,
            editData: frontJson,
            diagnosis: postData.data.client_document_diagnosis ?? [],
            editBy: postData.data.statusUpdatedUserName,
            editTime: postData.data.statusUpdatedDateTime,
            signed_at: postData.data.signed_at,
            signed,
            supervisorSigned,
            statusSuperVisorSigned: postData.data.statusUpdatedSupervisorUserName,
            signature: postData.data.signature,
            supervisor_signature: postData.data.supervisor_signature,
            supervisor_signed_at: postData.data.supervisor_signed_at,
            status_updated_by_role: postData.data.status_updated_by_role,
            created_by: postData.data.created_by ?? 0,
            supervisor_signed_by: postData.data.supervisor_signed_by ?? 0,
        }));
        setPayloadData((prev) => ({
            ...(prev && typeof prev === 'object' ? prev : {}),
            ...frontJson,
            client_document_id: documentId,
        }));
        setSelectAllData(frontJson);
        scheduleFrontJsonCheckboxRestore(frontJson);
        setCommonData((prev) => ({
            ...prev,
            date_of_service: postData.data.date_of_service,
            count: 1,
        }));
        rememberAssessmentDraftId(userInfo.id, documentId);
    };

    const isMountedRef = useRef(true);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const loadClientDocument = async (documentId) => {
        if (!documentId) {
            if (isMountedRef.current) {
                setDocumentMetaLoaded(true);
            }
            return;
        }
        const postData = await postRequest(
            '/client-document-info',
            { client_document_id: documentId },
            true
        );
        if (!isMountedRef.current) {
            return;
        }
        if (postData?.status && postData?.data) {
            const hasFrontJson =
                postData.data.front_json != null &&
                postData.data.front_json !== '' &&
                postData.data.front_json !== 'null';
            if (hasFrontJson) {
                applyLoadedClientDocument(postData, documentId);
            } else {
                const { signed, supervisorSigned } = resolveDocumentSignStatusesFromApi(
                    postData.data
                );
                applyCustomPracticeFromDoc(postData.data);
                if (postData.data.paragraph) {
                    setStatement(postData.data.paragraph);
                }
                setViewEdit((prev) => ({
                    ...prev,
                    confirmChange: postData.data.view_edit_flag ? true : false,
                    client_document_id: documentId,
                    signed,
                    supervisorSigned,
                    created_by: postData.data.created_by ?? prev.created_by ?? 0,
                    diagnosis: postData.data.client_document_diagnosis ?? prev.diagnosis,
                    editBy: postData.data.statusUpdatedUserName ?? prev.editBy,
                    editTime: postData.data.statusUpdatedDateTime ?? prev.editTime,
                }));
                setCommonData((prev) => ({
                    ...prev,
                    date_of_service: postData.data.date_of_service ?? prev.date_of_service,
                    count: 1,
                }));
            }
        } else if (documentId === readAssessmentDraftId(userInfo.id)) {
            clearAssessmentDraftId(userInfo.id);
        }
        if (isMountedRef.current) {
            setDocumentMetaLoaded(true);
        }
    };

    const setEditableCheckBox = async () => loadClientDocument(editId);

    const handleFrontJsonPersisted = useCallback((frontJson, documentId) => {
        const session = getSession('userData') || {};
        const mergedFrontJson = isCustomPractice
            ? mergeLiveCustomPracticeSessionMeta(
                frontJson,
                customPracticeMetaRef.current
            )
            : frontJson;
        setViewEdit((prev) => ({
            ...prev,
            client_document_id: documentId || prev.client_document_id,
            created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
        }));
        setSelectAllData(mergedFrontJson);
        setPayloadData((prev) => ({
            ...(prev && typeof prev === 'object' ? prev : {}),
            ...mergedFrontJson,
            client_document_id: documentId || prev?.client_document_id,
        }));
        if (documentId) {
            rememberAssessmentDraftId(userInfo.id, documentId);
        }
    }, [userInfo.id, isCustomPractice]);

    const handleFormSelectionChange = useCallback((selection) => {
        const mergedSelection = isCustomPractice
            ? mergeLiveCustomPracticeSessionMeta(
                selection,
                customPracticeMetaRef.current
            )
            : selection;
        setPayloadData((prev) => ({
            ...(prev && typeof prev === 'object' ? prev : {}),
            ...mergedSelection,
        }));
    }, [isCustomPractice]);

    const submitDatefunction = async () => {
        if (commonData.date_of_service === 'Invalid date') {
            setCommonData((prev) => ({
                ...prev,
                showError: true,
                isLoading: false,
                count: 22,
            }));
            return;
        }

        setCommonData((prev) => ({ ...prev, showError: false, isLoading: true }));

        const postData = await postRequest(
            '/set-date-of-service',
            {
                client_document_id: viewEdit.client_document_id,
                date_of_service: commonData.date_of_service,
                client_id: userInfo.id,
                document_type: 'assessment',
            },
            true
        );
        if (postData) {
            const session = getSession('userData') || {};
            setViewEdit((prev) => ({
                ...prev,
                client_document_id: postData.client_document_id,
                editData: prev.editData || {},
                created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
            }));
            rememberAssessmentDraftId(userInfo.id, postData.client_document_id);
            setCommonData((prev) => ({
                ...prev,
                showError: false,
                isLoading: false,
                count: 1,
                sessionDuration: '0',
                sessionDurationCheck: '0',
            }));
            if (isCustomPractice) {
                setCustomPracticeMeta((prev) => ({
                    ...getCustomPracticeMetaFromClient(userInfo),
                    ...prev,
                    ref_id: prev.ref_id || userInfo.ref_id || '',
                    ins_id: prev.ins_id || userInfo.ins_id || '',
                }));
            }
        } else {
            setCommonData((prev) => ({ ...prev, isLoading: false }));
        }
    };
    // latest-PI calling Commented
    // async function getLatestPiData() {
    //     console.log("Function Call", userInfo.id)
    //     const postData = await postRequest('/latest-PI', { client_id: userInfo.id, }, true);
    //     console.log(postData, 'LAtest APi Data')
    //     if (postData) {
    //         setLatestPiData(postData.data.latest_PI)
    //         console.log(latestPiData)
    //     } else {
    //         setCommonData({ ...commonData, showError: true, isLoading: false, count: 22 });
    //     }
    // }
    //changeCommon data
    const changeCommonData = useCallback(() => {
        if (viewEdit.client_document_id === 0) {
            setCommonData((prev) => ({ ...prev, count: 2 }));
        }
    }, [viewEdit.client_document_id]);

    const pareCommonData = useMemo(
        () => ({ commonData, changeCommonData }),
        [commonData, changeCommonData]
    );

    const sessionUser = getSession('userData') || {};
    const signOffState = resolveSignOffButtonState({
        signed: viewEdit.signed,
        supervisorSigned: viewEdit.supervisorSigned,
        userRoleSlug: userInfo.user_role_slug,
        userSupervisorId: userInfo.user_supervisor_id,
        documentCreatedBy: viewEdit.created_by,
        userId: sessionUser.id,
        clientSupervisorId: userInfo.client_supervisor_id,
    });
    checkSigned = signOffState.checkSigned;
    supervisorSigned = signOffState.supervisorSigned;
    showSigned = signOffState.showSigned;
    const {
        contentEditable,
        isViewOnlyDocument,
        showDocumentEditActions,
    } = resolveDocumentEditorAccess({
        editId,
        documentMetaLoaded,
        signed: viewEdit.signed,
        supervisorSigned: viewEdit.supervisorSigned,
        userRoleSlug: userInfo.user_role_slug,
        userId: sessionUser.id,
        clientCreatorId: userInfo.creator_id,
    });
    const clinicianFinalSignOnly = isClinicianFinalSignOnly(
        viewEdit.signed,
        viewEdit.supervisorSigned,
        userInfo.user_role_slug,
        sessionUser.id,
        userInfo.creator_id,
        viewEdit.created_by
    );

    //download
    const downloadDocument = async () => {
        let signatureText = "<div className='col-xs-12 mt-4'><hr />";

        signatureText += buildSignatureParagraphHtml(resolveDocumentSignatures({
            signed: viewEdit.signed,
            supervisor_signed: viewEdit.supervisorSigned,
            signature: viewEdit.signature,
            supervisor_signature: viewEdit.supervisor_signature,
            signed_at: viewEdit.editTime,
            supervisor_signed_at: viewEdit.supervisor_signed_at,
            status_updated_by_role: viewEdit.status_updated_by_role,
            created_by: viewEdit.created_by,
            supervisor_signed_by: viewEdit.supervisor_signed_by,
        }));
        signatureText += `</div>`;
        const postData = await postRequest("/download-client-document-pdf", 
            { 
                client_document_id: viewEdit.client_document_id,
                signature: signatureText
            }, true);
        if (postData) {
            const link = document.createElement('a');
            link.target = "_blank"
            // link.href = Url + (postData.split('/html')[1]);
            link.href = postData;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    function changeDateForService(e) {
        setCommonData((prev) => ({
            ...prev,
            date_of_service: moment(e).format('MM/DD/Y'),
        }));
        setTimeout(() => {
            $('#assesstmentStart').trigger('click');
        });
    }

    const getDateOfService = () => {
        return commonData.date_of_service;
    }

    React.useEffect(() => {
        let mounted = true;

        const loadAssessmentData = async () => {
            setLoading(true);
            try {
                await loadAssessmentTreatmentPlanMeta();
                if (!mounted) {
                    return;
                }
                if (editId > 0) {
                    await setEditableCheckBox();
                } else {
                    const draftId = readAssessmentDraftId(userInfo.id);
                    if (draftId > 0) {
                        await loadClientDocument(draftId);
                    }
                }
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        };

        loadAssessmentData();

        return () => {
            mounted = false;
        };
    }, []);

    // React.useEffect(() => {
    //     if(!viewEdit.confirmChange){
    //     const scrollDiv = document.getElementsByClassName('statementComponent__div')[0];
    //     scrollDiv.scrollTo(0, scrollDiv.offsetTop * 100)
    // }
    // }, [Statement])
    useEffect(() => {
        if (!viewEdit.confirmChange) {
          if ($(".scrollTODiv").length) {
            setTimeout(() => {
              $("#statementComponent__div_id_as").animate({
                scrollTop:
                  $("#statementComponent__div_id_as").scrollTop() +
                  ($(
                    '#statementComponent__div_id_as .scrollTODiv'
                  ).offset()?.top -
                    $("#statementComponent__div_id_as").offset()?.top),
              });
            }, 20);
          }
        }
      },[Statement])

    const isPageLoading = loading || Boolean(commonData.isLoading);
    const isNoteStarted = viewEdit.client_document_id !== 0;
    const showTopRowExtraFields = !isPageLoading && isNoteStarted;
    const blockMainFormInteraction =
        isPageLoading ||
        (editId > 0 && !documentMetaLoaded) ||
        isViewOnlyDocument ||
        (isCustomPractice && !isNoteStarted);

    return (
        <React.Fragment>
            <div className="row g-6 g-xl-9 note-editor-layout">
                {isViewOnlyDocument ? (
                    <div className="col-12">
                        <div className="alert alert-info mb-0">
                            This document cannot be edited.
                            {clinicianFinalSignOnly
                                ? ' Review the note below and use Sign Doc to apply your signature.'
                                : ' Use View to read the document.'}
                        </div>
                    </div>
                ) : null}
                {
                    !viewEdit.confirmChange && !isViewOnlyDocument
                        ? <>
                            <div className="col-lg-7 col-xxl-7 customUl">
                                <div className="card h-100 note-form-card">
                                    <div className="card-body p-9">
                                        {isCustomPractice ? (
                                            <>
                                                <div
                                                    className={`row g-3 g-lg-4 note-form-top-row note-form-date-top-row custom-practice-top-row assessment-custom-top-row progress-note-top-row${
                                                        showTopRowExtraFields
                                                            ? ' progress-note-top-row--started'
                                                            : ' progress-note-top-row--before-start'
                                                    }`}
                                                >
                                                    <div className="col-12 col-sm-12 col-md-8 col-lg-7 col-xl-6 progress-note-top-date note-form-date-column assessment-top-date">
                                                        <div className="note-form-field">
                                                            <label
                                                                className="form-label fw-bolder text-dark fs-6"
                                                                htmlFor="assessment-date-of-service"
                                                            >
                                                                Date Of Service
                                                            </label>
                                                            <div className="note-form-field__control note-form-date-actions">
                                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                    <DesktopDatePicker
                                                                        inputFormat="MM/dd/yyyy"
                                                                        value={moment.utc(moment(commonData.date_of_service)).format()}
                                                                        onChange={changeDateForService}
                                                                        disabled={loading}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                id="assessment-date-of-service"
                                                                                className="assessment-date-picker-input"
                                                                                fullWidth
                                                                                hiddenLabel
                                                                                placeholder="MM/DD/YYYY"
                                                                                size="small"
                                                                                disabled={loading}
                                                                                inputProps={{
                                                                                    ...params.inputProps,
                                                                                    readOnly: loading,
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                </LocalizationProvider>
                                                                <div
                                                                    className={`startEndDiv${
                                                                        commonData.isLoading
                                                                            ? ' startEndDiv--loading'
                                                                            : ''
                                                                    }`}
                                                                >
                                                                    {isPageLoading ? (
                                                                        <Loader
                                                                            type="ThreeDots"
                                                                            color="#017EAD"
                                                                            height={32}
                                                                            width={32}
                                                                            timeout={300000}
                                                                        />
                                                                    ) : (
                                                                        <button
                                                                            className={`btn btn-primary allNotes__dateOfServices__btn${
                                                                                commonData.count === 1
                                                                                    ? ' allNotes__dateOfServices__btn--icon-only'
                                                                                    : ''
                                                                            }`}
                                                                            id="assesstmentStart"
                                                                            type="button"
                                                                            onClick={submitDatefunction}
                                                                            disabled={!commonData.date_of_service || userInfo.client_diagnosis.length === 0}
                                                                            aria-label={commonData.count === 1 ? 'Edit date of service' : 'Start assessment'}
                                                                        >
                                                                            {commonData.count === 1 ? (
                                                                                <i className="fas fa-pencil-alt" />
                                                                            ) : (
                                                                                'Start Assessment'
                                                                            )}
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {(commonData.count == 22 || commonData.count > 1) ? (
                                                        <div className="col-12">
                                                            <b className="text-danger h6 mb-0">Please Start Assessment</b>
                                                        </div>
                                                    ) : null}
                                                    {showTopRowExtraFields ? (
                                                        <>
                                                            <div className="col-12 col-sm-12 col-md-4 col-lg-4 progress-note-top-session">
                                                                <CustomPracticeSessionDuration
                                                                    minutesValue={resolveCustomPracticeDisplaySessionMinutes(
                                                                        customPracticeMeta,
                                                                        commonData.sessionDuration
                                                                    )}
                                                                    disabled={viewEdit.client_document_id === 0}
                                                                    onDisabledClick={() =>
                                                                        setCommonData((prev) => ({ ...prev, count: 2 }))
                                                                    }
                                                                />
                                                            </div>
                                                            <CustomPracticeHeaderFields
                                                                meta={customPracticeMeta}
                                                                onFieldChange={onCustomPracticeFieldChange}
                                                                onFieldCommit={onCustomPracticeFieldCommit}
                                                                disabled={!contentEditable}
                                                            />
                                                        </>
                                                    ) : null}
                                                </div>
                                                {userInfo.client_diagnosis.length === 0 ? (
                                                    <div className="mb-3">
                                                        <b className="text-danger h3 mb-0">Please add diagnosis to create Assessment</b>
                                                    </div>
                                                ) : null}
                                            </>
                                        ) : (
                                            <>
                                                <div
                                                    className={`row g-3 g-lg-4 note-form-top-row note-form-date-top-row custom-practice-top-row assessment-custom-top-row assessment-standard-top-row progress-note-top-row${
                                                        showTopRowExtraFields
                                                            ? ' progress-note-top-row--started'
                                                            : ' progress-note-top-row--before-start'
                                                    }`}
                                                >
                                                    <div className="col-12 col-sm-12 col-md-8 col-lg-7 col-xl-6 progress-note-top-date note-form-date-column assessment-top-date">
                                                        <div className="note-form-field">
                                                            <label
                                                                className="form-label fw-bolder text-dark fs-6"
                                                                htmlFor="assessment-date-of-service"
                                                            >
                                                                Date Of Service
                                                            </label>
                                                            <div className="note-form-field__control note-form-date-actions">
                                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                    <DesktopDatePicker
                                                                        inputFormat="MM/dd/yyyy"
                                                                        value={moment.utc(moment(commonData.date_of_service)).format()}
                                                                        onChange={changeDateForService}
                                                                        disabled={loading}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                id="assessment-date-of-service"
                                                                                className="assessment-date-picker-input"
                                                                                fullWidth
                                                                                hiddenLabel
                                                                                placeholder="MM/DD/YYYY"
                                                                                size="small"
                                                                                disabled={loading}
                                                                                inputProps={{
                                                                                    ...params.inputProps,
                                                                                    readOnly: loading,
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                </LocalizationProvider>
                                                                <div
                                                                    className={`startEndDiv${
                                                                        commonData.isLoading
                                                                            ? ' startEndDiv--loading'
                                                                            : ''
                                                                    }`}
                                                                >
                                                                    {isPageLoading ? (
                                                                        <Loader
                                                                            type="ThreeDots"
                                                                            color="#017EAD"
                                                                            height={32}
                                                                            width={32}
                                                                            timeout={300000}
                                                                        />
                                                                    ) : (
                                                                        <button
                                                                            className={`btn btn-primary allNotes__dateOfServices__btn${
                                                                                commonData.count === 1
                                                                                    ? ' allNotes__dateOfServices__btn--icon-only'
                                                                                    : ''
                                                                            }`}
                                                                            id="assesstmentStart"
                                                                            type="button"
                                                                            onClick={submitDatefunction}
                                                                            disabled={
                                                                                !commonData.date_of_service ||
                                                                                userInfo.client_diagnosis.length === 0
                                                                            }
                                                                            aria-label={
                                                                                commonData.count === 1
                                                                                    ? 'Edit date of service'
                                                                                    : 'Start assessment'
                                                                            }
                                                                        >
                                                                            {commonData.count === 1 ? (
                                                                                <i className="fas fa-pencil-alt" />
                                                                            ) : (
                                                                                'Start Assessment'
                                                                            )}
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {(commonData.count == 22 || commonData.count > 1) ? (
                                                        <div className="col-12">
                                                            <b className="text-danger h6 mb-0">Please Start Assessment</b>
                                                        </div>
                                                    ) : null}
                                                </div>
                                                {userInfo.client_diagnosis.length === 0 ? (
                                                    <div className="mb-3">
                                                        <b className="text-danger h3 mb-0">Please add diagnosis to create Assessment</b>
                                                    </div>
                                                ) : null}
                                            </>
                                        )}
                                        <div
                                            className="note-form-main-section"
                                            aria-busy={blockMainFormInteraction}
                                        >
                                        {blockMainFormInteraction ? (
                                            <div
                                                className="note-form-loading-overlay"
                                                aria-hidden="true"
                                            />
                                        ) : null}
                                        {isCustomPractice && showTopRowExtraFields ? (
                                            <div
                                                className="row fv-row mb-5"
                                                style={{
                                                    position: 'sticky',
                                                    top: '7%',
                                                    zIndex: 99,
                                                    background: '#fff',
                                                    padding: '10px 0px',
                                                }}
                                            >
                                                <div className="col-xs-12 col-md-12">
                                                    <div className="card-title">
                                                        <div className="d-flex align-items-center position-relative my-1">
                                                            <span className="svg-icon svg-icon-1 position-absolute ms-6">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none">
                                                                    <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height={2} rx={1} transform="rotate(45 17.0365 15.1223)" fill="black" />
                                                                    <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                                                                </svg>
                                                            </span>
                                                            <input
                                                                ref={searchRef}
                                                                type="text"
                                                                id="searchContentAssessment"
                                                                className="form-control form-control-solid w-90% ps-15"
                                                                placeholder="Search Keyword..."
                                                                onChange={onOptimisedHandleChange}
                                                                disabled={commonData.count !== 1}
                                                            />
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: '#f5f8fa',
                                                                    borderColor: 'transparent',
                                                                    borderRadius: 0,
                                                                    padding: 10,
                                                                }}
                                                                onClick={clearSearch}
                                                                disabled={commonData.count !== 1}
                                                            >
                                                                x
                                                            </button>
                                                            <div
                                                                style={{
                                                                    backgroundColor: '#f5f8fa',
                                                                    borderColor: '#f5f8fa',
                                                                    borderRadius: 0,
                                                                    padding: 12,
                                                                }}
                                                            >
                                                                {totalSearch === 0 ? 0 : selectedSearchIndex + 1}/{totalSearch}
                                                            </div>
                                                            <span
                                                                className="searchIndexUpDown"
                                                                style={{ padding: 10 }}
                                                                onClick={() => onSelectedSearchIndex('up')}
                                                            >
                                                                Prev
                                                            </span>
                                                            <span
                                                                className="searchIndexUpDown"
                                                                style={{ padding: 10 }}
                                                                onClick={() => onSelectedSearchIndex('down')}
                                                            >
                                                                Next
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                        <div className="d-flex flex-column fv-row mb-7">
                                            <Pare
                                            selectAllData={selectAllData}
                                                setStatement={(e) => setStatement(e)}
                                                viewEdit={viewEdit}
                                                setViewEdit={(e) => {
                                                    const session = getSession('userData') || {};
                                                    setViewEdit((prev) => ({
                                                        ...prev,
                                                        client_document_id: e.client_document_id,
                                                        is_updated: e.is_updated,
                                                        created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
                                                    }));
                                                }}
                                                setAllData={setData}
                                                data={AssessmentJson}
                                                URL={URL}
                                                editMode={viewEdit.editData}
                                                commonData={pareCommonData} 
                                                setpayloadsData={setPayloadData}
                                                getDateOfService={getDateOfService}
                                                setSentenceLoader={setSentenceLoader}
                                                setCheckboxLoader={setCheckboxLoader}
                                                notes_id={viewEdit.notes_id}
                                                onFrontJsonPersisted={handleFrontJsonPersisted}
                                                onFormSelectionChange={handleFormSelectionChange}
                                                customPracticeMeta={
                                                    isCustomPractice ? customPracticeMeta : {}
                                                }
                                                customPracticeMetaRef={
                                                    isCustomPractice ? customPracticeMetaRef : null
                                                }
                                                accordionPreviewEpochRef={
                                                    isCustomPractice ? accordionPreviewEpochRef : null
                                                }
                                                />
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </>
                        : ""
                }
                <div className={`clientDetail__tour__step-six note-preview-column col-lg-${!viewEdit.confirmChange ? 5 : 12} col-xxl-${!viewEdit.confirmChange ? 5 : 12}`}>
                    <div className="card note-preview-card">
                        <div className="card-body p-9 note-preview-card-body">
                            { sentenceLoader && <div style={{
                                        position:'absolute',
                                        top:0,
                                        left:0,
                                        height:"100%",
                                        width:"100%",
                                        backdropFilter: "blur(1.5px)",
                                        zIndex: 99999,
                                        pointerEvents: 'none',
                                    }}>
                                      <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"100%", width:"100%",}}>
                                        <Loader
                                          type="ThreeDots"
                                          color="#017EAD"
                                          height={50}
                                          width={50}
                                          timeout={300000} />
                                      </div>
                                </div>
                            }
                            <div className="">
                                {
                                    viewEdit.confirmChange
                                        ? (viewEdit.diagnosis
                                            ? <div>
                                                <h2>Diagnosis</h2>
                                                {
                                                    viewEdit.diagnosis.map((e) => {
                                                        return e.diagnosis !== null
                                                            ? <div className='d-inline-block bg-grey rounded selected_diagnosis m-2'>
                                                                <div className='d-flex selected_diagnosis__div'>
                                                                    <p>{e.diagnosis.name}  </p>
                                                                </div>
                                                            </div>
                                                            : ""
                                                    }
                                                    )
                                                }
                                                <hr />
                                            </div>
                                            : "")
                                        : ""
                                }
                            </div>
                            <div className="note-preview-header cust__diagnosis_addNew_spaceBet">
                                <label className="form-label text-dark fs-6 mb-0">
                                    <span className="fw-bolder">{userInfo.full_name}</span>
                                    {(Statement || isNoteStarted) && isCustomPractice ? (
                                        <>
                                            <br />
                                            <span>
                                                <span className="fw-bolder">DOB:</span>{' '}
                                                {moment(userInfo.dob).format('MM/DD/Y')}
                                            </span>
                                        </>
                                    ) : null}
                                </label>
                                <label className="form-label text-dark fs-6 mb-0 note-preview-header__meta">
                                    <span className="fw-bolder">Assessment</span>
                                    {(Statement || isNoteStarted) && isCustomPractice ? (
                                        <div>
                                            {commonData.date_of_service ? (
                                                <label>
                                                    <span className="fw-bolder">Date Of Service: </span>
                                                    {moment(commonData.date_of_service).format('MM/DD/Y')}
                                                </label>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </label>
                            </div>
                            <div
                                className={`d-flex flex-column statementComponent__div fv-row mb-7${
                                    viewEdit.confirmChange
                                        ? ' statementComponent__div--editor'
                                        : ' scroll_statement_div'
                                }`}
                                id="statementComponent__div_id_as"
                                style={
                                    viewEdit.confirmChange
                                        ? { scrollPaddingTop: '50px' }
                                        : { maxHeight: '500px', scrollPaddingTop: '50px' }
                                }
                            >
                                {
                                    viewEdit.confirmChange
                                        ? <CKEditor
                                            editor={ClassicEditor}
                                            name="test"
                                            data={Statement}
                                            config={{ toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'] }}
                                            onChange={(event, editor) => setStatement(editor.getData())}
                                        > </CKEditor>
                                        : (
                                            <div className="fs-6 text-dark form-label mb-0" id="assessmentNote">
                                                <div
                                                    style={{ fontSize: '16px' }}
                                                    dangerouslySetInnerHTML={{ __html: Statement }}
                                                />
                                            </div>
                                        )
                                }
                            </div>
                            <div className="d-flex flex-wrap fv-row mb-7">
                                {
                                    Statement !== ''
                                        ? <button className="btn btn-primary btn-sm me-3 mb-3" onClick={() => { setViewEdit({ ...viewEdit, viewStatement: true }) }}>View</button>
                                        : ""
                                }
                                {
                                    showDocumentEditActions
                                        ? viewEdit.confirmChange
                                            ? <button className="btn btn-info btn-sm me-3 mb-3" onClick={() => saveStatement()}>Save</button>
                                            : <button className="btn btn-info btn-sm me-3 mb-3" disabled={Statement == '' ? true : false} onClick={() => saveStatement()}>Save</button>
                                        : ""
                                }
                                {
                                    showDocumentEditActions && !viewEdit.confirmChange
                                        ? <button className="btn btn-danger btn-sm me-3 mb-3" disabled={Statement == '' ? true : false} onClick={() => setViewEdit({ ...viewEdit, showModal: true })}>Manually edit</button>
                                        : ""
                                }
                                {
                                    (Statement !== '' || (showSigned == 0 || viewEdit.is_updated !== 0))
                                        ? <button className="btn btn-success btn-sm me-3 mb-3"
                                            onClick={() => setSignOff({ ...SignOff, signOff: true, supervisor_signed: supervisorSigned, signed: checkSigned })}>
                                            {getSignOffButtonLabel(checkSigned)}
                                        </button>
                                        : ""
                                }
                                <button className="btn btn-warning btn-sm me-3 mb-3" onClick={downloadDocument} disabled={Statement === ''}>
                                    <i className='fa fa-file-download' style={{ width: "10px" }}></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <CustModal show={viewEdit.showModal} close={() => setViewEdit({ ...viewEdit, showModal: false })} header="Are you sure you would like to manually edit your text now?">
                <div className="row">
                    <div className="col-xs-12">
                        <div className='h5'>
                            Are you sure you want to manually edit your document? Once you do, you will no longer have access to the keywords.
                        </div>
                    </div>
                    <div className="col-xs-12 mt-4">
                        <div className="">
                            <button className="btn btn-primary mx-2" onClick={() => setViewEdit({ ...viewEdit, showModal: false, confirmChange: true })}>Yes, manually edit</button>
                            <button className="btn btn-danger mx-2" onClick={() => setViewEdit({ ...viewEdit, showModal: false })}>No, return to keyword selections</button>
                        </div>
                    </div>
                </div>
            </CustModal>

            <CustModal show={SignOff.signOff} close={() => setSignOff({ ...SignOff, signOff: false })} header="Ready to sign doc?" size="sm">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>
                            Are you sure you would like to {getSignOffConfirmPrompt(checkSigned)} ?
                        </h4>
                    </div>
                    <div className="col-xs-12 mt-4">
                        <div className="">
                            <button className="btn btn-primary mx-2" onClick={() => signOffFun()}>Confirm</button>
                            <button className="btn btn-danger mx-2" onClick={() => setSignOff({ ...SignOff, signOff: false })}>Cancel</button>
                        </div>
                    </div>
                </div>
            </CustModal>

            <CustModal show={viewEdit.viewStatement} close={() => setViewEdit({ ...viewEdit, viewStatement: false })} header={userInfo.full_name} size="lg" centerHeader="Assessment">
                <div className="row">
                    {/* <div className="col-xs-12">
                        {
                            commonData.date_of_service
                                ? <div className='mb-2'><h4>Date Of Service</h4><label>{Moment(commonData.date_of_service).format('DD-MM-YYYY')}</label><hr /></div>
                                : ""
                        }
                        {viewEdit.diagnosis
                            ? <div>
                                <h4>Diagnosis</h4>
                                {
                                    viewEdit.diagnosis.map((e) => {
                                        return e.diagnosis !== null
                                            ? <div className='d-inline-block bg-grey rounded selected_diagnosis m-2'>
                                                <div className='d-flex selected_diagnosis__div'>
                                                    <p>{e.diagnosis.name}  </p>
                                                </div>
                                            </div>
                                            : ""
                                    }
                                    )
                                }
                                <hr />
                            </div>
                            : ""
                        }
                    </div> */}
                    <div className="col-xs-12">
                        <div dangerouslySetInnerHTML={{ __html: stripEmbeddedSignaturesFromHtml(Statement) }} />
                    </div>
                    {
                        (() => {
                            const signatures = resolveDocumentSignatures({
                                signed: viewEdit.signed,
                                supervisor_signed: viewEdit.supervisorSigned,
                                signature: viewEdit.signature,
                                supervisor_signature: viewEdit.supervisor_signature,
                                signed_at: viewEdit.editTime,
                                supervisor_signed_at: viewEdit.supervisor_signed_at,
                                status_updated_by_role: viewEdit.status_updated_by_role,
                                created_by: viewEdit.created_by,
                                supervisor_signed_by: viewEdit.supervisor_signed_by,
                            });
                            if (!signatures.clinician.show && !signatures.supervisor.show) {
                                return '';
                            }
                            return (
                                <div className="col-xs-12 mt-4">
                                    <hr />
                                    {signatures.clinician.show ? <p>{formatSignatureLine(signatures.clinician.text, signatures.clinician.at)}</p> : ""}
                                    {signatures.supervisor.show ? <p>{formatSignatureLine(signatures.supervisor.text, signatures.supervisor.at)}</p> : ""}
                                </div>
                            );
                        })()
                    }
                    <div className="col-xs-12 mt-4">
                        <hr />
                        <div className="">
                            <button className="btn btn-primary rounded-sm mx-2" onClick={() => setViewEdit({ ...viewEdit, viewStatement: false })}>Ok</button>
                        </div>
                    </div>
                </div>
            </CustModal>

            <CustModal show={viewEdit.confirmSave} close={() => setViewEdit({ ...viewEdit, confirmSave: false })} header="Success" size="sm">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>
                            Document is saved
                        </h4>
                    </div>
                    <div className="col-xs-12 mt-4">
                        <div className="">
                            <button className="btn btn-primary mx-2" onClick={() => changePage({ id: 6 })}>Go to Profile</button>
                            <button className="btn btn-danger mx-2" onClick={() => setViewEdit({ ...viewEdit, confirmSave: false })}>Continue</button>
                        </div>
                    </div>
                </div>
            </CustModal>
        </React.Fragment>
    )
}

export default Assessment